import { type ConsentId, isConsentGranted } from "./consent"

interface ExtendedStorage extends Omit<Storage, "setItem"> {
  setItemAtUserRequest: Storage["setItem"]
  setItemIfConsent(consentId: ConsentId, key: string, value: string): void
}

const TEST_KEY = "__storage_test__"

const extendedStorage = (storage: Storage): ExtendedStorage => ({
  clear: storage.clear.bind(storage),
  getItem: storage.getItem.bind(storage),
  key: storage.key.bind(storage),
  removeItem: storage.removeItem.bind(storage),
  get length(): number {
    return storage.length
  },

  // Explicit function to denote user-requested action that does not require consent.
  setItemAtUserRequest: storage.setItem.bind(storage),

  setItemIfConsent: (consentId: ConsentId, key: string, value: string): void => {
    if (isConsentGranted(consentId)) {
      storage.setItem(key, value)
    }
  }
})

const tryStorage = (storageKey: "localStorage" | "sessionStorage"): Nullable<ExtendedStorage> => {
  try {
    const storage = window[storageKey]
    storage.setItem(TEST_KEY, TEST_KEY)
    storage.removeItem(TEST_KEY)
    return extendedStorage(storage)
  } catch {
    return null
  }
}

const localStorage = tryStorage("localStorage")
const sessionStorage = tryStorage("sessionStorage")

export { localStorage, sessionStorage }
